export default {
  // 头部
  publish: "Post",
  housingInfo: "Apartment/House",
  travelRoutes: "Travel Routes",
  postHousing: "Post Housing",
  postTravel: "Post Travel",
  headerSearchPlaceholder: "Please enter content",
  logoutSuccess: "Logged out",
  pleaseEnterContent: "Please enter content",
  aboutMe: "About Me",
  merchantCert: "Merchant Certification",
  logout: "Log Out",
  // 底部
  aboutUs: "About Us",
  contactUs: "Contact Us",
  followUs: "Follow Us",
  phoneFooter: "Phone",
  email: "Email",
  address: "Address",
  copyright: "© 2026 Move2china.com All Rights Reserved",
  recordNo: "Hu ICP Bei 17051552-1",
  // 悬浮工具栏
  wechatQRCode: "WeChat QR Code",
  scanWechatContactService: "Scan WeChat<br/>Contact Service",
  customerService: "Service",
  servicePhone: "Service Phone: ",
  collect: "Collect",
  collected: "Collected",
  backToTop: "Back To Top",
  expand: "Expand",
  collapse: "Collapse",
  phoneCopied: "Phone copied",
  copyFailedPleaseRecord: "Copy failed, please record manually",
  // TravelSchedule 行程安排
  theDay: "Day",
  deleteDay: "Delete Day",
  selectTime: "Select Time",
  spot: "Spot",
  detail: "Detail",
  addSpot: "Add Spot",
  addDay: "Add Day",
  spotDetailPlaceholder: "Spot {num} Detail",
  editorPlaceholder: "Please enter spot details (images and styles allowed)",
  keepAtLeastOneDay: "Please keep at least one day schedule",
  editorNotReady: "Editor is not ready",
  insertImageFailed: "Failed to insert image, please try again",
  // 导航栏
  allInfo: "All Info",
  underReview: "Under Review",
  approved: "Approved",
  rejected: "Rejected",
  // 搜索栏
  station: " Station",
  departureLocation: " (Departure)",
  searchPlaceholder: "Enter destination / scenic spot / theme",
  search: "Search",
  loadingCityData: "Loading city data...",
  loadCityFailed: "Failed to load city data, please try again",
  retry: "Retry",
  recentCities: "Recent Cities",
  clear: "Clear",
  searchCityPlaceholder: "Search by Chinese / initials",
  searchCity: "Search City",
  // 首页
  hotServiceCategory: "Hot Service Categories",
  swipeToSeeMore: "Swipe for more",
  recommendedServices: "Recommended Services",
  bookNow: "Book Now",
  recommendedHouses: "Recommended Houses",
  viewMore: "View More",
  trustedPlatform: "Trusted Service Platform",
  trustedPlatformDesc:
    "Trusted by over 100,000 users, our professional team is here to help you",
  houseType: "Type",
  area: "Area",
  evaluation: "Reviews",
  // 登录注册
  login: "Login",
  register: "Register",
  forgetPassword: "Forget Password?",
  backToLogin: "Back to Login",
  findPassword: "Reset Password",
  resetPassword: "Reset Password",
  phone: "Phone",
  password: "Password",
  confirmPassword: "Confirm Password",
  newPassword: "New Password",
  username: "Username",
  captcha: "Captcha",
  smscode: "SMS Code",
  getCaptcha: "Get Code",
  resendAfter: "s resend",
  pleaseEnterPhone: "Please enter phone number",
  pleaseEnterValidPhone: "Please enter a valid phone number",
  pleaseEnterPassword: "Please enter password",
  passwordLength: "Password length 6-20 characters",
  pleaseEnterCaptcha: "Please enter captcha",
  pleaseEnterUsername: "Please enter username",
  usernameLength: "Username length 2-10 characters",
  captchaLength: "Captcha is 4 digits",
  pleaseEnterRegisterPhone: "Please enter registered phone",
  pleaseRepeatPassword: "Please repeat new password",
  formValidateFailed: "Form validation failed",
  loginSuccess: "Login Success!",
  registerSuccess: "Register Success",
  goToLogin: "Go to Login?",
  passwordResetSuccess: "Password Reset Success",
  // 个人中心侧边栏
  myListings: "My Listings",
  routeTemplate: "Route Template",
  favoriteList: "Favorite List",
  // 个人中心基本信息
  basicInfo: "Basic Info",
  changeAvatar: "Change Avatar",
  avatarTip: "JPG/PNG supported, recommended size 100x100",
  account: "Account",
  wechat: "WeChat",
  registerTime: "Registered At",
  edit: "Edit",
  cancel: "Cancel",
  save: "Save",
  pleaseInputUsername: "Please enter username",
  pleaseInputEmail: "Please enter email",
  pleaseInputWechat: "Please enter WeChat",
  avatarUploadSuccess: "Avatar upload success",
  avatarFormatError: "Only JPG/PNG allowed!",
  avatarSizeError: "Avatar must be less than 5MB!",
  saveSuccess: "Save success",
  saveFailed: "Save failed, please try again",
  // 个人中心实名认证
  realNameAuth: "Real-name Authentication",
  authTip:
    "Real-name authentication will directly affect account content publishing.",
  authDoc: "Real-name Authentication Documents",
  enterpriseAuth: "Enterprise Certification",
  changeEnterpriseAuth: "Modify Enterprise Certification",
  changeRecord: "Change Records",
  noAuthTip:
    "You have not completed merchant certification. Please complete it to use all functions normally.",
  goToAuth: "Go to Certify",
  enterpriseName: "Enterprise Name",
  companyType: "Company Type",
  creditCode: "Unified Social Credit Code",
  handlerName: "Signatory Name",
  handlerIdCard: "Signatory ID Number",
  applyTime: "Application Time",
  authMethod: "Authentication Method",
  //  个人中心商户认证变更
  merchantAuth: "Merchant Authentication",
  changeAuthTip:
    "Changing enterprise authentication will update your company information. It does not affect the use of existing information during review.",
  basicInfo1: "Basic Information",
  merchantName: "Merchant Name",
  registerAddress: "Registered Address",
  businessAddress: "Actual Business Address",
  licenseStartDate: "Business License Start Date",
  licenseEndDate: "Business License Expiry Date",
  selectDate: "Select Date",
  selectType: "Select Type",
  selectCompanyType: "Please select company type",
  selectLastLevel: "Please select the last level of company type",
  businessLicense: "Business License",
  uploadBusinessLicense: "Upload Business License",
  businessPermit: "Business Permit (if required by the industry)",
  uploadBusinessPermit: "Upload Business Permit",
  signerInfo: "Signer Information",
  signerName: "Signer Name",
  idCardNumber: "ID Card Number",
  position: "Position",
  selectPosition: "Please select position",
  idCardPhoto: "ID Card Photo",
  idCardFront: "ID Card Front",
  idCardBack: "ID Card Back",
  uploadClickOrDrag: "Click or drag to upload the original photo or scan",
  uploadFormatTip: "Supports JPG, JPEG, PNG formats, max file size 5MB",
  uploadPdfTip: "Supports PDF, JPG, JPEG, PNG formats, max file size 5MB",
  delete: "Delete",
  submitCheck: "Submit for Review",
  submitChange: "Submit Change",
  uploading: "Uploading, please wait...",
  fillRequiredInfo: "Please complete all required information",
  uploadRequiredFiles: "Please upload all required document photos",
  submitSuccess: "Submitted successfully, waiting for review",
  changeSubmitSuccess: "Change application submitted successfully",
  operationFailed: "Operation failed",
  onlyAllowJpgPngPdf: "Only JPG, PNG or PDF files are allowed!",
  fileSizeLimit: "File size cannot exceed 5MB!",
  pleaseInputMerchantName:
    "Please enter the company name on the business license",
  pleaseInputCreditCode: "Please enter the unified social credit code",
  pleaseInputValidCreditCode: "Please enter a valid 18-digit credit code",
  pleaseInputRegisterAddress:
    "Please enter the registered address on the business license",
  pleaseInputBusinessAddress: "Please enter the actual business address",
  pleaseSelectLicenseStartDate: "Please select business license start date",
  pleaseSelectLicenseEndDate: "Please select business license expiry date",
  pleaseInputSignerName: "Please enter signer name",
  pleaseInputIdCard: "Please enter 18-digit ID card number",
  pleaseInputValidIdCard: "Please enter a valid ID card number",
  pleaseUploadBusinessLicense: "Please upload business license",
  pleaseUploadIdCardFront: "Please upload ID card front photo",
  pleaseUploadIdCardBack: "Please upload ID card back photo",
  uploadError: "An error occurred during upload, please try again",
  uploadFailed: "Upload failed",
  getAuthInfoFailed: "Failed to get authentication information",
  getAuthInfoFailedRetry:
    "Failed to get authentication information, please try again",
  fileUploadFailed: "File upload failed",
  draftSaved: "Draft saved",
  draftRestored: "Previous draft restored",
  draftRestoreFailed: "Failed to restore draft",
  file: "File",
  deleted: "Deleted",
  // 个人中心更改手机号
  changePhone: "Change Phone",
  back: "Back",
  currentPhone: "Current Phone",
  newPhone: "New Phone",
  verifyCode: "Verification Code",
  pleaseInputCurrentPhone: "Please input current phone",
  pleaseInputNewPhone: "Please input new phone",
  pleaseInputValidPhone: "Please input a valid phone number",
  pleaseInputVerifyCode: "Please input verification code",
  getVerifyCode: "Get Code",
  pleaseInputNewPhoneFirst: "Please input new phone first",
  phoneNoNeedChange: "New phone is same as current one, no need to change",
  codeSent: "Verification code sent",
  getCodeFailedRetry: "Failed to get code, please try again",
  phoneChangeSuccess: "Phone changed successfully",
  changeFailedRetry: "Failed to change, please try again",
  //  个人中心收藏列表
  collectionList: "My Collections",
  routeName: "Route Name",
  searchRoutePlaceholder: "Search by route name / departure / destination",
  filter: "Filter",
  reset: "Reset",
  coverImage: "Cover Image",
  routeCover: "Route Cover",
  tripDays: "Trip Days",
  departure: "Departure",
  destination: "Destination",
  price: "Price",
  collectTime: "Collect Time",
  operation: "Action",
  cancelCollection: "Uncollect",
  loadListFailed: "Failed to load list",
  // 个人中心订单列表
  orderList: "Order List",
  searchOrder: "Search Order",
  searchOrderPlaceholder: "Search order No. or name",
  orderNo: "Order No.",
  productName: "Product Name",
  travelDate: "Travel Date",
  status: "Status",
  createTime: "Create Time",
  goToPay: "Pay Now",
  cancelOrder: "Cancel Order",
  shareReview: "Review",
  reviewed: "Reviewed",
  allOrders: "All Orders",
  pendingPayment: "Pending Payment",
  pendingTravel: "Pending Travel",
  completed: "Completed",
  loadOrderListFailed: "Failed to load order list",
  viewOrderDetail: "View order ",
  confirmCancelOrder: "Are you sure to cancel this order?",
  tip: "Tip",
  confirm: "Confirm",
  orderCancelSuccess: "Order canceled successfully!",
  orderCancelFailed: "Failed to cancel order!",
  cancelOrderClosed: "Cancel order closed",
  travelDateFormatError: "Invalid travel date format",
  orderExpiredCannotPay: "Order expired, cannot pay",

  // 旅游路线列表
  touristRoutes: "Tourist Routes",
  day: " Day",
  enable: "Enable",
  disable: "Disable",
  addTravelPlan: "Add Travel Plan",
  getRouteListFailed: "Failed to get route list",
  networkErrorGetRouteFailed: "Network error, failed to get route list",
  thisRoute: " this route",
  success: "Success",
  failed: "Failed",
  networkErrorOperateFailed: "Network error, operation failed",
  // 行程发布
  clickSelectRoute: "Click to select route",
  noTemplateTip:
    "You have not created any route template, please create one first",
  trip: "Trip",
  createNewRoute: "Create New Route",
  noTemplateAvailable: "No available route template, please add first",
  selectTravelDate: "Select travel date",
  pleaseSelectRouteTemplate: "Please select route template",
  pleaseSelectTravelDate: "Please select travel date",
  pleaseDoMerchantAuthFirst: "Please complete merchant authentication first",
  getTemplateFailed: "Failed to get template",
  networkErrorGetTemplateFailed: "Network error, failed to get template",
  tripPublishSuccessWaitReview:
    "Trip published successfully, waiting for review",
  publishFailedRetry: "Publish failed, please try again",
  networkErrorPublishFailed: "Network error, publish failed",
  // 路线发布（英文）
  routeImageGallery: "Route Image Gallery",
  cover: "Cover",
  setAsCover: "Set as Cover",
  dragOrClickUpload: "Drag files here or click to upload",
  pleaseEnterRouteName: "Please enter route name",
  pleaseEnterTripDays: "Please enter trip days",
  daysMustBeGreaterThanZero: "Days must be greater than 0",
  pleaseSelectOrSearchDeparture: "Select or search departure",
  pleaseSelectOrSearchDestination: "Select or search destination",
  pleaseEnterDeparture: "Please enter departure",
  pleaseEnterDestination: "Please enter destination",
  minGroupSize: "Min Group Size",
  maxGroupSize: "Max Group Size",
  pleaseEnterMinGroupSize: "Please enter min group size",
  pleaseEnterMaxGroupSize: "Please enter max group size",
  mustBeGreaterThanZero: "Must be greater than 0",
  productFeatures: "Product Features",
  enterTagPressEnter: "Enter tag and press Enter",
  pleaseAddAtLeastOneFeature: "Add at least one feature",
  pleaseEnterPrice: "Please enter price",
  priceMustBeGreaterThanZero: "Price must be greater than 0",
  tripMode: "Trip Mode",
  pleaseSelectTripMode: "Please select trip mode",
  playTheme: "Play Theme",
  pleaseSelectAtLeastOneTheme: "Select at least one theme",
  introduction: "Introduction",
  pleaseEnterRouteIntro: "Please enter route intro",
  pleaseEnterIntroduction: "Please enter introduction",
  routeDetail: "Route Details",
  pleaseEnterRouteDetail: "Please enter route details",
  tripSchedule: "Trip Schedule",
  pleaseAddAtLeastOneDayTrip: "Add at least one day trip",
  eachDayMustHaveAtLeastOneSpot: "Each day needs at least one spot",
  costDescription: "Cost Description",
  pleaseEnterCostDescription: "Please enter cost description",
  servicePromise: "Service Promise",
  pleaseSelectAtLeastOneServicePromise: "Select at least one service promise",
  bookingNotice: "Booking Notice",
  pleaseEnterBookingNotice: "Please enter booking notice",
  publishRoute: "Publish Route",
  formReset: "Form has been reset",
  onlyImagesCanBeUploaded: "Only images can be uploaded!",
  pleaseUploadAtLeastOneImage: "Please upload at least one image",
  uploadingPleaseWait: "Uploading, please wait...",
  uploadingFile: "Uploading file...",
  uploadErrorPleaseRetry: "Upload error, please try again",
  imageUploadFailed: "Image upload failed",
  imageUploadFailedPleaseRetry: "Image upload failed, please try again",
  insertImageFailedPleaseRetry: "Insert image failed, please try again",
  loadEditDataFailed: "Failed to load edit data",
  getCityListFailed: "Failed to get city list:",
  getCityListErrorPleaseRetry: "Error getting city list, please retry",
  publishSuccess: "Publish successful",
  publishFailedPleaseRetry: "Publish failed, please try again",
  editSuccess: "Edit successful",
  editFailedPleaseRetry: "Edit failed, please try again",
  networkErrorOperationFailed: "Network error, operation failed",
  pleaseInputChineseOnly: "Only Chinese is allowed for {field}",
  pleaseInputEnglishOnly: "Only English is allowed for {field}",
  langRuleTip: "You can only publish Chinese content in Chinese mode",
  langRuleTipEn: "You can only publish English content in English mode",
  // 订单评价
  orderEvaluation: "Order Review",
  traveler: "Traveler",
  orderAmount: "Order Amount",
  shareYourExperience: "Share Your Experience",
  overallRating: "Overall Rating",
  reviewContent: "Review Content",
  pleaseShareTravelExperience: "Please share your travel experience...",
  uploadImages: "Upload Images",
  uploadImageTip: "Max 5 images, JPG/PNG only",
  submitReview: "Submit Review",
  reviewSubmittedSuccessfully: "Review submitted, thank you!",
  veryPoor: "Very Poor",
  average: "Average",
  good: "Good",
  veryGood: "Very Good",
  excellent: "Excellent",
  pleaseGiveRating: "Please give a rating",
  pleaseEnterReviewContent: "Please enter review content",
  reviewContentMaxLength: "Max 500 characters",
  maxUpload5Images: "Max 5 images",
  canStillUpload: "You can still upload",
  images: " images",
  ratingLowContactService: "Please contact service if you are dissatisfied",
  reviewSubmitFailed: "Review submit failed",
  networkErrorOrderInfoFailed: "Network error, failed to load order info",
  networkErrorReviewSubmitFailed: "Network error, review submit failed",
  // 路线列表
  travelMode: "Travel Mode",
  groupSize: "Group Size",
  priceRange: "Price Range",
  all: "All",
  minPrice: "Min",
  maxPrice: "Max",
  yuan: "",
  currencySymbol: "¥",
  yuanAbove: "+",
  clearFilters: "Clear Filters",
  selected: "Selected",
  itemsFound: "items found",
  sortBy: "Sort by",
  publishDate: "Publish Date",
  sales: "Sales",
  perPerson: "/Person",
  score: "Score",
  sold: "Sold",
  noResult: "No matching products",
  travelGuide: "Travel Guide",
  hotTop5: "Hot Top 5",
  loadFailedRetry: "Load failed, please retry",
  minNotGreaterThanMax: "Min price cannot exceed max price",
  // 行程详情
  share: "Share",
  routeImage: "Route Image",
  thumbnail: "Thumbnail",
  productInfo: "Product Info",
  productNo: "Product No.",
  departDest: "Departure/Destination",
  recentTrip: "Recent Trip",
  undetermined: "TBD", // TBD = To Be Determined，英文中"待定"的常用简洁表达
  historySales: "Historical Sales",
  order: "Order",
  satisfaction: "Satisfaction",
  commentCount: "Number of Comments",
  piece: "Piece",
  serviceProviderTip1: "This trip will be provided by",
  serviceProviderTip2: "for your service",
  routeIntro: "Route Introduction",
  costInfo: "Cost Information",
  basedOn: "Based on",
  reviews: "Reviews",
  adult: "Adult",
  room: "Room",
  themeRec: "Theme Recommendation",
  recentDate: "Recent Trip Date",
  to: "to",
  serviceProvider: "Service Provider",
  unknownProvider: "Unknown Provider",
  totalPrice: "Total Price",
  userReviews: "User Reviews",
  avatar: "User Avatar",
  reviewImg: "Review Image",
  viewAll: "View All",
  total: "Total",
  loading: "Loading...",
  noMore: "No more reviews",
  getDateFailed: "Failed to get available dates",
  pleaseSelectDate: "Please select a travel date",
  pleaseFillBookingInfo: "Please fill in complete booking information",
  linkCopied: "Share link copied",
  copyFailed: "Copy failed, please copy manually",
  getReviewFailed: "Failed to get reviews",
  networkErrorGetReviewFailed: "Network error, failed to get reviews",
  roomCannotExceedAdult: "Number of rooms cannot exceed number of adults",
  autoAdjustTo: "Automatically adjusted to",
  current: "Current",
  person: "Person",
  // 支付页面
  confirmPayment: "Confirm Payment",
  orderInfo: "Order Info",
  bookCount: "Booked Count",
  roomCount: "Rooms",
  roomUnit: "Room",
  payAmount: "Payment Amount",
  totalPay: "Total Amount",
  feeIncludeTip: "Fees include transportation & services, see order details",
  selectPayMethod: "Select Payment Method",
  alipay: "Alipay",
  wechatPay: "WeChat Pay",
  preparingPay: "Preparing",
  payQrcode: "Payment QR Code",
  qrcodeExpire: "QR Code Expiry",
  timeoutRefresh: "Refresh if expired",
  scannedPleasePay: "Scanned, please complete payment",
  openPayTool: "Open {method}",
  scanQrcodePay: "Scan QR code to pay",
  refreshQrcode: "Refresh QR Code",
  paidAlready: "Already Paid?",
  qrcodeExpiredRefresh: "QR Code expired, please regenerate",
  refreshNow: "Regenerate Now",
  generatingQrcode: "Generating {method} QR Code",
  payResult: "Payment Result",
  paySuccess: "Payment Success",
  payUnfinished: "Payment Unfinished",
  checkingPayStatus: "Checking Payment Status",
  paySuccessTip: "Payment successful, order confirmed in 1-5 mins",
  payUnfinishedTip: "No payment detected, please pay or refresh",
  checkingStatusTip: "Checking status, please wait...",
  viewOrder: "View Order",
  backToDetail: "Back to Details",
  orderInfoFail: "Failed to get order info",
  defaultRoute: "Default Travel Route",
  createPayOrderFail: "Create payment order failed",
  networkError: "Network error, check connection",
  generatedQrcode: "Generated",
  qrcodeGenerateFail: "Failed to generate QR code",
  requestError: "Request error, contact support",
  qrcodeExpiredTip: "QR Code expired, reselect method",
};
